import { Box, Grid } from '@material-ui/core';
import SkeletonPulse from './SkeletonPulse';
import PodcastSkeletonLoader from './PodcastSkeletonLoader';

interface CategoryPodcastSkeletonLoaderType {
  numOfCategories?: number;
  numOfPodcasts?: number;
  backgroundColor?: string;
}

const CategoryPodcastSkeletonLoader = ({
  numOfCategories = 3,
  numOfPodcasts = 10,
  backgroundColor
}: CategoryPodcastSkeletonLoaderType) => {
  return Array.from({ length: numOfCategories }, (_, index) => (
    <Box key={index} mb={5}>
      <Grid container spacing={2} direction="column">
        <Grid item>
          <SkeletonPulse
            width="250"
            height="28"
            backgroundColor={backgroundColor}
          />
        </Grid>
        <Grid item>
          <Grid container spacing={3} wrap="wrap">
            {Array.from({ length: numOfPodcasts }, (_, i) => (
              <Grid key={i} item>
                <PodcastSkeletonLoader backgroundColor={backgroundColor} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  ));
};

export default CategoryPodcastSkeletonLoader;
